"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CookieKeysEnum;
(function (CookieKeysEnum) {
    CookieKeysEnum["Token"] = "Token";
    CookieKeysEnum["ImpersonatingToken"] = "ImpersonatingToken";
    CookieKeysEnum["AuthenticationUrl"] = "AuthenticationUrl";
    CookieKeysEnum["PostADLoginRedirectUrl"] = "PostADLoginRedirectUrl";
    CookieKeysEnum["SessionTimeoutRedirectUrl"] = "SessionTimeoutRedirectUrl";
    CookieKeysEnum["UserSettings"] = "UserSettings";
    CookieKeysEnum["CurrentMenuItemKey"] = "CurrentMenuItems";
    CookieKeysEnum["FeatureFlags"] = "FeatureFlags";
})(CookieKeysEnum = exports.CookieKeysEnum || (exports.CookieKeysEnum = {}));
//# sourceMappingURL=CookieKeysEnum.js.map